const directionsQueue = {
  top: ['top', 'bottom', 'right', 'left'],
  left: ['left', 'right', 'top', 'bottom'],
  right: ['right', 'left', 'top', 'bottom'],
  bottom: ['bottom', 'top', 'right', 'left']
};
export function getDirectionsQueue(direction) {
  return Array.isArray(direction) ? direction : directionsQueue[direction];
}